import { styled, Radio as Radio$1, iconButtonClasses } from "@mui/material";
const Radio = styled(Radio$1)(({ theme }) => ({
  color: theme.palette.grey[800],
  margin: -9,
  marginRight: 9,
  [`&.${iconButtonClasses.root}`]: {
    marginRight: 0,
    "&.Mui-checked": {
      color: theme.palette.primary.main
    }
  },
  "& .MuiIconButton-label": {
    width: theme.spacing(3),
    height: theme.spacing(3)
  }
}));
Radio.defaultProps = {
  color: "primary"
};
export {
  Radio
};
